export const GUTTER = 2;

export const initialRect = {
  left: 0,
  top: 0,
  height: 0,
  width: 0,
};
